var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog110(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_110"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_110",
    "data-name": 110,
    className: "cls-2",
    d: "M2.1,60.51C-2.75,37.33,34,20.42,51.65,19c20.48-1.71,62.93,10.52,39.1,37.25-11,12.38-27.14,22-44,24.49C32,82.9,5.85,78.36,2.1,60.51Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cat_309"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: -59,
    width: 100,
    height: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog110);
export default __webpack_public_path__ + "static/media/dog_110.1e4463185be2e36e7d792d1957c830b0.svg";
export { ForwardRef as ReactComponent };